import { useState } from 'react';
import { faqItems } from '@/mocks/faq';
import { mainSiteUrl } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-semibold mb-4 whitespace-nowrap">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-medium mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            Everything you need to know about the AllChinaBuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-50/50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.question}</span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-2xl p-8 border border-background-200/70 text-center">
          <h3 className="font-heading text-xl text-foreground-900 font-medium mb-2">
            Ready to Start Exploring?
          </h3>
          <p className="text-sm text-foreground-500 mb-5">
            Access the best AllChinaBuy Spreadsheet with thousands of trusted finds, updated daily.
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-full text-sm font-semibold whitespace-nowrap transition-all cursor-pointer"
          >
            Browse Spreadsheet Now
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}